import {Component, Input} from '@angular/core';
import {Product, TranslatePipe} from '@spartacus/core';
import {DcpPriceCommonServicePlanFeaturesData} from '@app/model/price/dcp-price-common-service-plan-features-data';
import {PlansAndPricingDataService} from '../plans-and-pricing-data.service';
import {CheckmarkListComponent} from '../../../../shared/checkmark-list/checkmark-list.component';

@Component({
  selector: 'dcp-plans-and-pricing-common-features',
  templateUrl: './plans-and-pricing-common-features.component.html',
  styleUrls: ['./plans-and-pricing-common-features.component.scss'],
  imports: [CheckmarkListComponent, TranslatePipe],
})
export class PlansAndPricingCommonFeaturesComponent {
  commonServicePlanFeatures: DcpPriceCommonServicePlanFeaturesData[];

  constructor(private plansAndPricingDataService: PlansAndPricingDataService) {}

  @Input() set product(product: Product) {
    this.commonServicePlanFeatures = this.plansAndPricingDataService.getCommonServicePlanFeatures(product.data);
  }
}
